<!--
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-11-26 14:56:17
 * @LastEditors:  weirongwei@danghuan.com
 * @LastEditTime: 2024-11-28 11:56:38
 * @FilePath: \eu-eswop-web-external\src\views\order\component\banner.vue
 * @Description:
-->
<template>
  <div class="home">
    <div class="main-content" v-if="isMaxScreen">
      <img v-if="lang == 'es'" src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/banner-es-pc.png" alt="" class="banner-img">
      <img v-if="lang == 'en'" src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/banner-en-pc.png" alt="" class="banner-img">
    </div>
    <div class="main-content" v-else>
      <!-- <img src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/banner-h5.png" alt="" class="banner-img"> -->
      <img v-if="lang == 'es'" src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/APP_banner_es@3x.png" alt="" class="banner-img">
      <img v-if="lang == 'en'" src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/APP_banner_en@3x.png" alt="" class="banner-img">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { orderReject } from '../../../services/api/brandList.js'
export default {
  name: 'btnDialog',
  components: {
  },
  props: {
  },
  data () {
    return {
      dialogVisible: false,
      lang: sessionStorage.getItem('lang') || 'es'
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    })
  },
  methods: {
  }
}
</script>
<style scoped lang="less">
.banner-img{
  width: 100%;
}

@media (max-width: 980px) {

}

@media (min-width: 981px) {


}
</style>
